import React from 'react';
import { Target, Users, Calendar, CheckSquare } from 'lucide-react';

const HowFractionalWorks = () => {
  const structurePoints = [
    {
      icon: <Target className="h-6 w-6 text-burnt-orange" />,
      text: "Choose a package based on workload"
    },
    {
      icon: <Users className="h-6 w-6 text-burnt-orange" />,
      text: "We agree on scope + tools + access rules"
    },
    {
      icon: <Calendar className="h-6 w-6 text-burnt-orange" />,
      text: "We set a weekly rhythm (priorities, updates, reviews)"
    },
    {
      icon: <CheckSquare className="h-6 w-6 text-burnt-orange" />,
      text: "You get consistent execution without micromanaging"
    }
  ];

  return (
    <section id="how-fractional-works" className="section-padding bg-gray-50">
      <div className="container-center">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center space-y-6 mb-16 animate-slide-up">
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
              What "fractional" looks like in real life.
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-12">
            {/* Description */}
            <div className="text-center space-y-6">
              <p className="text-xl text-olive-brown/80 leading-relaxed">
                Fractional engagement means you get structured support without the overhead of hiring full-time. 
                You're not buying "random hours." You're buying outcomes: smoother days, less noise, better follow-through.
              </p>
            </div>

            {/* How it's structured */}
            <div className="space-y-8">
              <h3 className="text-2xl font-semibold text-olive-brown text-center mb-8">
                How it's structured:
              </h3>
              
              <div className="grid md:grid-cols-2 gap-6">
                {structurePoints.map((point, index) => (
                  <div 
                    key={index}
                    className="flex items-start space-x-4 p-6 bg-white rounded-xl card-shadow animate-slide-up"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="p-2 bg-burnt-orange/20 rounded-full mt-1">
                      {point.icon}
                    </div>
                    <p className="text-olive-brown/80 leading-relaxed">
                      {point.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Bottom Message */}
            <div className="text-center pt-8 border-t border-olive-brown/20">
              <p className="text-burnt-orange font-medium italic">
                Start lean, then expand when the workflow is stable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowFractionalWorks;